import formatPrice from '../functions/formatPrice';
import getCurrency from '../functions/getCurrency';
import { querySelector, querySelectorAll } from './querySelectors';
import { SELECT_CLASS } from '../scripts/typo';
import productChangeWedding from '../functions/productChangeWedding';
import {
  THUMB_IMAGE_CLASS,
  THUMB_ACTIVE_CLASS
} from '../scripts/productGallery.js';
import {
  isDiamondSelector,
  DIAMOND_SELECTOR_CLASS
} from '../functions/select';
import {
  productChangeV2
} from '../functions/productChangeV2';
import checkDetailInfo from './checkDetailInfo';
import { setListenersFromSelector } from './listeners';
import { EXPRESS_CHECKBOX_CLASS, showExpressOption, hideExpressOption } from '../scripts/productDetail';
import { U_DN_CLASS } from '../config/main';
import changeDelivery from '../functions/changeDelivery';

const CHOOSE_ELEMENT_CLASS = 'c-product-choose';
export const METAL_ATTR = 'data-metal';
const CERT_LINK_CLASS = 'js-diamond-cert-yes-link';
const SHAPE_CLASS = 'js-diamond-summary-shape';
const COLOR_CLASS = 'js-diamond-summary-color';
const CLARITY_CLASS = 'js-diamond-summary-clarity';
const CUT_CLASS = 'js-diamond-summary-cut';
const NAME_CLASS = 'js-diamond-summary-name';
export const METAL_CLASS = 'js-metal-select';
export const PRICE_BEFORE_CLASS = 'js-price-before';
const PRICE_BEFORE_ATTR = 'data-price-before';
export const TOTAL_PRICE_CLASS = 'js-total-price';
export const DEFAULT_PRICE_ATTR = 'data-default-price';
export const TOTAL_PRICE_ATTR = 'data-total-price';
export const TOTAL_PRICE_DEFAULT_WITHOUT_VAT_ATTR = 'data-default-price-without-vat';
export const TOTAL_PRICE_WITHOUT_VAT_ATTR = 'data-price-without-vat';
export const MATERIAL_ATTR = 'data-material';
export const WEDDING_SWITCHER_CLASS = 'js-ring-switcher';
export const CHOICE_DATA_CLASS = 'js-product-choice-data';
export const ORIGINAL_NAME_ATTR = 'data-original-name';
export const ORIGINAL_NAME_LONG_ATTR = 'data-original-name-long';
export const DELIVERY_CLASS = 'js-delivery-option-item';
export const DELIVERY_ID_ATTR = 'data-delivery-id';
export const METAL_WEIGHT_DEST_CLASS = 'js-weight';
export const DISCOUNT_TOP_CLASS = 'c-product-intro__discount';
export const EXTEND_PRICE_CLASS = 'js-form-extend-price';
export const EXTEND_PRICE_ATTR = 'data-extend-price';
export const EXTEND_PRICE_WITHOUT_VAT_ATTR = 'data-extend-price-without-vat';
export const EXTEND_PRICE_TEXT_CLASS = 'js-price-addon';
export const EXTEND_PRICE_TEXT_ATTR = 'data-extend-price-text';
const PRODUCT_WEDDING_CLASS = 'js-product-wedding';
export const ITEM_DESC_CLASS = 'c-product-description__item';
const PERSONALIZATION_SWITCHER_CLASS = 'js-personalized-switcher';
const PERSONALIZATION_SWITCH_CLASS = 'js-personalized-switch';
const IS_PERSONALIZATION_CLASS = 'is-persionalization';
export const EXPRESS_PRICE_ATTR = 'data-express-price';
const EXTEND_PRICE_CHECKBOX_CLASS = 'js-form-extend-price';
const ENGRAVING_SWITCH_ID = 'engraving-switch';
const ENGRAVE_DELIVERY_CLASS = 'js-engrave-delivery';
const TEXT_DELIVERY_CLASS = 'js-express-text-element';

let metalsPrices = window.metals_prices;
let metalsPricesWithoutVat = window.metals_prices_without_vat;
let diamondsPrices = window.diamonds_prices;
let diamondsPricesWithoutVat = window.diamonds_prices_without_vat;
let diamondsCerts = window.diamonds_certs;
let diamondsShapes = window.diamonds_shapes;
let diamondsColors = window.diamonds_colors;
let diamondsClarities = window.diamonds_clarities;
let diamondsCuts = window.diamonds_cuts;
let diamondsNames = window.diamonds_names;
let productChoices = window.product_choices;
let expresPriceRates = window.expres_prices_rates;

export function getDefaultDeliveryId() {
  return window.product_delivery_id;
};

export function getDeliveries() {
  return window.deliveries_data || [];
};

let getWrapper = function() {
  return querySelector(`.${CHOOSE_ELEMENT_CLASS}`);
};

let getMetal = function() {
  return querySelector(`.${METAL_CLASS}`);
};

let getDiamondSelector = function() {
  return querySelector(`.${DIAMOND_SELECTOR_CLASS}`);
};

export let getPriceBefore = function() {
  return parseInt(getPriceBeforeElement().getAttribute(PRICE_BEFORE_ATTR), 10);
};

export let getPriceBeforeElement = function() {
  return querySelector(`.${PRICE_BEFORE_CLASS}`);
};

let getDefaultPrice = function() {
  let item = querySelector(`.${TOTAL_PRICE_CLASS}[${DEFAULT_PRICE_ATTR}]`);

  return parseInt(item.getAttribute(DEFAULT_PRICE_ATTR), 10);
};

let getDefaultWithoutVatPrice = function() {
  let item = querySelector(`.${TOTAL_PRICE_CLASS}[${TOTAL_PRICE_DEFAULT_WITHOUT_VAT_ATTR}]`);

  if (item) {
    return parseInt(item.getAttribute(TOTAL_PRICE_DEFAULT_WITHOUT_VAT_ATTR), 10);
  }
};

export function addonTexts(form) {
  let addonElements = querySelectorAll(`.${EXTEND_PRICE_CLASS}`, form);
  let addonText = '';

  addonElements.forEach((addonElement) => {
    if (addonElement.checked) {
      if (addonElement.getAttribute(EXTEND_PRICE_TEXT_ATTR)) {
        addonText += `${addonElement.getAttribute(EXTEND_PRICE_TEXT_ATTR)} `;
      }
    }
  });

  let addonTextElement = querySelector(`.${EXTEND_PRICE_TEXT_CLASS}`);

  if (addonTextElement) {
    addonTextElement.textContent = addonText;
  }
};

export function setTotalPrice(price, deliveryId) {
  let addToPrice = 0;
  let extensions = querySelectorAll(`.${EXTEND_PRICE_CHECKBOX_CLASS}:checked`);

  extensions.forEach((item) => {
    if (item.getAttribute(EXTEND_PRICE_ATTR)) {
      let price = parseInt(item.getAttribute(EXTEND_PRICE_ATTR), 10);
      addToPrice += typeof price === 'number' ? price : 0;
    }
  });

  let items = querySelectorAll(`.${TOTAL_PRICE_CLASS}`);
  let formatedPrice = `${formatPrice(expressAddonPrice(deliveryId, price) + addToPrice)} ${getCurrency()}`;

  items.forEach((item) => {
    item.setAttribute(TOTAL_PRICE_ATTR, price);
    item.textContent = formatedPrice;
  });
};

export function setWithoutVatPrice(price, deliveryId) {
  let addToPrice = 0;
  let extensions = querySelectorAll(`.${EXTEND_PRICE_CHECKBOX_CLASS}:checked`);

  extensions.forEach((item) => {
    if (item.getAttribute(EXTEND_PRICE_WITHOUT_VAT_ATTR)) {
      let price = parseInt(item.getAttribute(EXTEND_PRICE_WITHOUT_VAT_ATTR), 10);
      addToPrice += typeof price === 'number' ? price : 0;
    }
  });

  let items = querySelectorAll(`.${TOTAL_PRICE_CLASS}`);

  items.forEach((item) => {
    item.setAttribute(TOTAL_PRICE_WITHOUT_VAT_ATTR, expressAddonPrice(deliveryId, price) + addToPrice);
  });
};

let checkPrice = function(changedSelect) {
  if (productChoices) {
    productChangeV2(changedSelect);
    checkDetailInfo();
    return;
  }

  if (querySelector(`.${DIAMOND_SELECTOR_CLASS}`)) {
    let price = 0;
    let priceWithoutVat = 0;
    let discount = 0;
    let metal = getMetal();
    let metalValue = null;
    let beforePriceElement = getPriceBeforeElement();

    if (metal) {
      metalValue = parseInt(metal.options[metal.options.selectedIndex].value, 10);
    }

    if (price === 0) {
      if (!metalValue) {
        price = getDefaultPrice();
        priceWithoutVat = getDefaultWithoutVatPrice();
      }
      else if (typeof diamondsPrices === 'undefined' || !getDiamondSelector()) {
        price = metalsPrices[metalValue];
        priceWithoutVat = metalsPricesWithoutVat[metalValue];
      }
      else {
        price = metalsPrices[metalValue] + diamondsPrices[getDiamondSelector().value];
        priceWithoutVat = metalsPricesWithoutVat[metalValue] + diamondsPricesWithoutVat[getDiamondSelector().value];
      }
    }

    addonTexts(getWrapper());
    setTotalPrice(price, getDefaultDeliveryId());
    setWithoutVatPrice(priceWithoutVat, getDefaultDeliveryId());

    if (beforePriceElement) {
      let priceBefore = getPriceBefore();

      if (discount && discount !== 0) {
        priceBefore = price + discount;
        beforePriceElement.setAttribute(PRICE_BEFORE_ATTR, priceBefore);
        beforePriceElement.textContent = `${formatPrice(priceBefore)} ${getCurrency()}`;
      }

      if (priceBefore > price) {
        beforePriceElement.style.display = 'block';
      }
      else {
        beforePriceElement.style.display = 'none';
      }
    }

    querySelectorAll(`.${SELECT_CLASS}`, getWrapper()).forEach((select) => {
      checkSelect(select);
    });

    checkDetailInfo();
  }
};

let setValueTo = function(newValue, elementClass) {
  let items = querySelectorAll(`.${elementClass}`);

  items.forEach((item) => {
    if (newValue) {
      item.parentNode.classList.remove(U_DN_CLASS);
      item.textContent = newValue;
    }
    else {
      item.parentNode.classList.add(U_DN_CLASS);
      item.textContent = '';
    }
  });
};

let isWithMetal = function(item) {
  if (item) {
    return typeof item.getAttribute(METAL_ATTR) === 'string';
  }

  return false;
};

let isWedding = function() {
  if (querySelector(`.${PRODUCT_WEDDING_CLASS}`)) {
    return true;
  }

  return false;
};

let checkMetalPrices = function(activeItem, select) {
  let activeValue = parseInt(activeItem.value, 10);
  let actualPrice = metalsPrices[activeValue];
  let currency = getCurrency();
  let options = querySelectorAll('option', select);

  options.forEach((option) => {
    let diff = '';
    let currentValue = parseInt(option.value, 10);

    if (activeValue !== currentValue) {
      diff = metalsPrices[currentValue] - actualPrice;

      if (diff !== 0) {
        diff = `(${formatPrice(diff, true)} ${currency})`;
      }
      else {
        diff = '';
      }
    }

    option.textContent = `${option.getAttribute(ORIGINAL_NAME_ATTR)} ${diff}`;

    // eslint-disable-next-line no-undef
    let customEvent = new CustomEvent('changeName');
    option.dispatchEvent(customEvent);
  });
};

let checkMetal = function(activeItem, select) {
  if (isWithMetal(activeItem)) {
    if (window.imagesArray.length) {
      let newActive = querySelector(`.${THUMB_IMAGE_CLASS}[${METAL_ATTR}="${activeItem.getAttribute(MATERIAL_ATTR)}"]`);

      if (newActive && !newActive.parentNode.classList.contains(THUMB_ACTIVE_CLASS)) {
        newActive.click();
      }
    }

    checkMetalPrices(activeItem, select);
  }
};

let checkDiamond = function(activeItem, select) {
  if (isDiamondSelector(select)) {
    let itemValue = parseInt(activeItem.value, 10);
    let certLink = querySelector(`.${CERT_LINK_CLASS}`);

    // certifikat
    if (certLink) {
      if (diamondsCerts[itemValue] !== undefined && diamondsCerts[itemValue] !== '') {
        certLink.style.display = 'inline';
        querySelector(`.${CERT_LINK_CLASS}`).setAttribute('href', diamondsCerts[itemValue]);
      }
      else {
        certLink.style.display = 'none';
      }
    }

    // tvar
    setValueTo(diamondsShapes[itemValue], SHAPE_CLASS);

    // barva
    setValueTo(diamondsColors[itemValue], COLOR_CLASS);

    // clarity
    setValueTo(diamondsClarities[itemValue], CLARITY_CLASS);

    // brus
    setValueTo(diamondsCuts[itemValue], CUT_CLASS);

    // name
    setValueTo(diamondsNames[itemValue], NAME_CLASS);
  }
};

let checkSelect = function(select) {
  let activeItem = select.options[select.options.selectedIndex];

  checkMetal(activeItem, select);
  checkDiamond(activeItem, select);
};

let expressAddonPrice = function(deliveryId, originalPrice, type = 'hidden') {
  //changeDelivery(deliveryId, null, null);

  if (window.deliveries_data && window.deliveries_data[deliveryId] && window.deliveries_data[deliveryId].expres) {
    showExpressOption();
  }
  else {
    hideExpressOption();
  }

  let express = querySelector(`.${EXPRESS_CHECKBOX_CLASS}[type="${type}"]`);
  let returnPrice = originalPrice;

  if (express) {
    if ((parseInt(express.value, 10) && type === 'hidden') || (express.checked && type === 'checkbox')) {
      if (expresPriceRates) {
        try {
          let lastPrice = 0;
          let lastRate = 0;

          for (const [key, value] of Object.entries(expresPriceRates[deliveryId])) {
            if (originalPrice <= parseInt(key, 10) && originalPrice > lastPrice) {
              returnPrice = originalPrice * ((parseInt(value, 10) / 100) + 1);
            }

            if (key === '>') {
              lastRate = parseInt(value, 10);
            }
            else {
              lastPrice = parseInt(key, 10);
            }
          }

          if (originalPrice > lastPrice) {
            returnPrice = originalPrice * ((lastRate / 100) + 1);
          }
        }
        catch (e) {
          returnPrice = originalPrice * (parseFloat(express.getAttribute(EXPRESS_PRICE_ATTR)) + 1);
        }
      }
      else {
        returnPrice = originalPrice * (parseFloat(express.getAttribute(EXPRESS_PRICE_ATTR)) + 1);
      }
    }
  }

  return returnPrice;
};

let personalizationChange = function(event) {
  let isChecked = querySelector(`.${PERSONALIZATION_SWITCHER_CLASS}:checked`);
  let allItems = querySelectorAll(`.${PERSONALIZATION_SWITCH_CLASS}`);

  if (isChecked) {
    allItems.forEach((item) => {
      item.classList.add(IS_PERSONALIZATION_CLASS);
    });
  }
  else {
    allItems.forEach((item) => {
      item.classList.remove(IS_PERSONALIZATION_CLASS);
    });
  }
};

let extendPriceChange = function(event) {
  if (this.getAttribute('id') === ENGRAVING_SWITCH_ID) {
    let deliveries = querySelectorAll(`.${ENGRAVE_DELIVERY_CLASS}`);

    deliveries.forEach((delivery) => {
      let secondDelivery = querySelector(`.${TEXT_DELIVERY_CLASS}`, delivery.parentNode);

      if (this.checked) {
        delivery.classList.remove(U_DN_CLASS);
        secondDelivery.classList.add(U_DN_CLASS);
      }
      else {
        delivery.classList.add(U_DN_CLASS);
        secondDelivery.classList.remove(U_DN_CLASS);
      }
    });
  }
};

export function productChange(changedSelect) {
  setListenersFromSelector(
    `.${PERSONALIZATION_SWITCHER_CLASS}`,
    `i-${PERSONALIZATION_SWITCHER_CLASS}`,
    personalizationChange,
    true,
    'change'
  );

  setListenersFromSelector(
    `.${EXTEND_PRICE_CHECKBOX_CLASS}`,
    `i-${EXTEND_PRICE_CHECKBOX_CLASS}`,
    extendPriceChange,
    true,
    'change'
  );

  if (isWedding()) {
    productChangeWedding(changedSelect);
  }
  else {
    checkPrice(changedSelect);
  }
};
